<template>
  <div class="login-page">
    <div class="login-bg">
      <!-- Logo -->
      <img class="logo-header" :src="require('./login-img/logo-header.png')" />

      <!-- 返回首页 -->
      <div class="back-home" @click="$router.push('/')">
        <img class="back-icon" :src="require('./login-img/FigmaDDSSlicePNGcabdd2f009de209dbd020527e67df803.png')" />
        <span class="back-text">返回首页</span>
      </div>

      <!-- 已经有账号，去登录 -->
      <div class="login-hint" @click="$router.push('/login')">已经有账号，去登录</div>

      <!-- 卡片 -->
      <div class="login-card">
        <!-- 标题行（无 Tab，只有标题） -->
        <div class="title-bar">
          <span class="title-text">{{ type === '2' ? '企业忘记密码' : '个人忘记密码' }}</span>
          <div class="title-underline"></div>
        </div>

        <!-- 表单 -->
        <div class="form-body">
          <!-- 手机号 -->
          <div class="input-row">
            <div class="phone-icon"></div>
            <div class="divider-line"></div>
            <input class="input-field" type="text" v-model="form.mobile" placeholder="请输入注册手机号" maxlength="11" />
          </div>
          <div class="error-tip">{{ errors.mobile || '\u00a0' }}</div>

          <!-- 验证码 -->
          <div class="input-row">
            <img class="sms-icon" :src="require('./login-img/FigmaDDSSlicePNG41e10afccef3a0d5ace19978898d13ea.png')" />
            <input class="input-field" type="text" v-model="form.code" placeholder="请输入短信验证码" maxlength="6" />
            <div class="code-btn" @click="sendCode">{{ countdown > 0 ? countdown + 's后重发' : '获取验证码' }}</div>
          </div>
          <div class="error-tip">{{ errors.code || '\u00a0' }}</div>

          <!-- 新密码 -->
          <div class="input-row">
            <img class="pwd-icon" :src="require('./login-img/FigmaDDSSlicePNG41e10afccef3a0d5ace19978898d13ea.png')" />
            <input class="input-field" type="password" v-model="form.password" placeholder="请输入新的登录密码" />
          </div>
          <div class="error-tip">{{ errors.password || '\u00a0' }}</div>

          <!-- 确认密码 -->
          <div class="input-row">
            <img class="pwd-icon" :src="require('./login-img/FigmaDDSSlicePNG41e10afccef3a0d5ace19978898d13ea.png')" />
            <input class="input-field" type="password" v-model="form.confirmPassword" placeholder="请再次输入登录密码" />
          </div>
          <div class="error-tip">{{ errors.confirmPassword || '\u00a0' }}</div>

          <!-- 同意协议 -->
          <div class="agree-row" @click="agreed = !agreed">
            <div class="agree-box" :class="{ checked: agreed }">
              <div class="agree-inner" v-if="agreed"></div>
            </div>
            <span class="agree-text">我同意《中国品牌》杂志社的相关规定</span>
          </div>

          <!-- 提交按钮 -->
          <div class="login-btn" @click="handleSubmit">提&nbsp;&nbsp;交</div>
        </div>
      </div>

      <!-- 版权 -->
      <div class="copyright">
        《中国品牌》杂志社、中国品牌网&nbsp;&nbsp;&nbsp;&nbsp;法律顾问：北京市信之源律师事务所<br />
        Copyright © 2008-2028 cbrand.com.cn All rights reserved 中国品牌网版权所有<br />
        京ICP备 16035947 号
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForgetPassword',
  data() {
    return {
      agreed: true,
      countdown: 0,
      timer: null,
      form: { mobile: '', code: '', password: '', confirmPassword: '' },
      errors: { mobile: '', code: '', password: '', confirmPassword: '' }
    }
  },
  computed: {
    type() {
      return this.$route.query.type || '1'
    }
  },
  methods: {
    sendCode() {
      if (this.countdown > 0) return
      if (!this.form.mobile || !/^1[3-9]\d{9}$/.test(this.form.mobile)) {
        this.errors.mobile = '请输入正确的手机号'
        return
      }
      this.errors.mobile = ''
      this.countdown = 60
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) clearInterval(this.timer)
      }, 1000)
    },
    handleSubmit() {
      this.errors = { mobile: '', code: '', password: '', confirmPassword: '' }
      if (!this.form.mobile) { this.errors.mobile = '请输入手机号'; return }
      if (!this.form.code) { this.errors.code = '请输入验证码'; return }
      if (!this.form.password) { this.errors.password = '请输入新密码'; return }
      if (!this.form.confirmPassword) { this.errors.confirmPassword = '请再次输入密码'; return }
      if (this.form.password !== this.form.confirmPassword) { this.errors.confirmPassword = '两次密码不一致'; return }
      this.$router.push('/login')
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  }
}
</script>

<style scoped>
* { box-sizing: border-box; margin: 0; padding: 0; }

.login-page {
  width: 1400px;
  min-height: 1161px;
  margin: 0 auto;
  background: #fff;
}

.login-bg {
  width: 1400px;
  min-height: 1161px;
  background: url('./login-img/FigmaDDSSlicePNGa9da2e2723302094c7132a362227dc1f.png') center top / cover no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Logo */
.logo-header {
  width: 577px;
  margin-top: 40px;
  object-fit: contain;
}

/* 返回首页 */
.back-home {
  display: flex;
  align-items: center;
  width: 577px;
  margin-top: 50px;
  cursor: pointer;
}
.back-icon { width: 22px; height: 20px; margin-right: 10px; }
.back-text {
  color: rgba(136, 136, 136, 1);
  font-size: 22px;
  font-family: Microsoft YaHei, sans-serif;
}

/* 去登录 */
.login-hint {
  width: 577px;
  text-align: right;
  margin-top: 21px;
  color: rgba(102, 102, 102, 1);
  font-size: 15px;
  font-family: Microsoft YaHei, sans-serif;
  cursor: pointer;
  position: relative;
  z-index: 3;
}
.login-hint:hover { color: rgba(160, 0, 0, 1); }

/* 卡片 */
.login-card {
  width: 577px;
  background: rgba(255, 255, 255, 1);
  border-radius: 16px;
  margin-top: 8px;
  overflow: hidden;
}

/* 标题行 */
.title-bar {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 30px 60px 0;
}
.title-text {
  font-size: 22px;
  color: rgba(228, 2, 16, 1);
  font-family: Microsoft YaHei, sans-serif;
  font-weight: bold;
}
.title-underline {
  width: 32px;
  height: 3px;
  background: rgba(228, 2, 16, 1);
  border-radius: 2px;
  margin-top: 8px;
}

/* 表单主体 */
.form-body {
  padding: 10px 60px 40px;
  background: rgba(255, 255, 255, 1);
}

/* 输入框行 */
.input-row {
  display: flex;
  align-items: center;
  background: rgba(245, 250, 255, 1);
  border: 1px solid rgba(228, 242, 255, 1);
  border-radius: 24px;
  height: 50px;
  padding: 0 6px 0 18px;
  margin-top: 20px;
}
.phone-icon {
  width: 14px; height: 21px; flex-shrink: 0;
  background: url('./login-img/FigmaDDSSlicePNG1665c2a5d0482cc85b2c49298ea04615.png') center/contain no-repeat;
}
.sms-icon { width: 18px; height: 18px; flex-shrink: 0; }
.pwd-icon { width: 14px; height: 18px; flex-shrink: 0; }
.divider-line {
  width: 1px; height: 20px; flex-shrink: 0;
  background: rgba(200, 210, 220, 1);
  margin: 0 10px;
}
.input-field {
  flex: 1; min-width: 0; border: none; outline: none;
  background: transparent; font-size: 14px;
  font-family: Microsoft YaHei, sans-serif;
  color: rgba(51, 51, 51, 1);
  margin-left: 8px;
}
.input-field::placeholder { color: rgba(178, 178, 178, 1); }

/* 获取验证码按钮 */
.code-btn {
  flex-shrink: 0;
  height: 36px;
  padding: 0 14px;
  background: rgba(160, 0, 0, 1);
  border-radius: 18px;
  color: #fff;
  font-size: 13px;
  font-family: Microsoft YaHei, sans-serif;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer;
  white-space: nowrap;
  margin-left: 8px;
}
.code-btn:hover { background: rgba(130, 0, 0, 1); }

/* 错误提示 */
.error-tip {
  height: 24px; line-height: 24px;
  font-size: 13px; color: rgba(249, 130, 136, 1);
  padding-left: 18px; margin-top: 2px;
}

/* 同意协议 */
.agree-row {
  display: flex; align-items: center;
  margin-top: 16px; cursor: pointer;
}
.agree-box {
  width: 14px; height: 14px; flex-shrink: 0;
  border: 1px solid rgba(228, 2, 16, 1);
  position: relative;
}
.agree-box.checked { background: rgba(228, 2, 16, 1); }
.agree-inner {
  width: 8px; height: 6px;
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(-45deg);
  position: absolute; top: 2px; left: 1px;
}
.agree-text {
  font-size: 14px; color: rgba(102, 102, 102, 1);
  font-family: Microsoft YaHei, sans-serif;
  margin-left: 8px;
}

/* 提交按钮 */
.login-btn {
  width: 100%; height: 52px;
  background: rgba(160, 0, 0, 1);
  border-radius: 26px;
  display: flex; align-items: center; justify-content: center;
  color: #fff; font-size: 18px; letter-spacing: 4px;
  font-family: Microsoft YaHei, sans-serif;
  cursor: pointer; margin-top: 16px;
  transition: background 0.2s;
}
.login-btn:hover { background: rgba(130, 0, 0, 1); }

/* 版权 */
.copyright {
  width: 577px;
  text-align: center;
  font-size: 14px; color: rgba(102, 102, 102, 1);
  font-family: Microsoft YaHei, sans-serif;
  line-height: 24px; margin-top: 60px;
}
</style>
